// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .cs-p {
  font-size: 2rem !important;
}
::ng-deep .about-form-wrapper {
  border: none !important;
  border-radius: 1.5rem !important;
}

p-accordion, app-ready-for-solar {
  width: 100%;
}

.cs-field {
  display: flex;
  margin-bottom: 1rem;
}

.cs-number {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 5px solid var(--secondary);
  font-size: 32px;
  display: flex;
  justify-content: center;
  line-height: 50px;
}
.cs-number p {
  color: var(--secondary);
  line-height: normal;
  display: inline-block;
  vertical-align: middle;
}

.about-form-wrapper {
  padding: 0;
  overflow: auto;
}

.max-content {
  width: 100%;
  height: 100%;
}

.box-outer {
  display: table;
  overflow: hidden;
  padding: 20px;
  z-index: 1;
}

.box-inner {
  display: table-cell;
  overflow: auto;
  filter: none;
}

.bg-image {
  background-image: url('rooftop-solar-suburb.jpeg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.modal-2 {
  background-color: rgba(255, 255, 255, 0.95);
  color: #000;
}

@supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
  .modal-2 {
    -webkit-backdrop-filter: blur(15px);
    backdrop-filter: blur(15px);
    background-color: rgba(255, 255, 255, 0.4);
  }
  .warning {
    display: none;
  }
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .box-outer {
    padding: 0;
  }
  .cs-field {
    padding: 0 10px;
  }
  ::ng-deep .cs-col {
    padding: 0 !important;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .box-outer {
    padding: 0;
  }
  .cs-field {
    padding: 0 10px;
  }
  ::ng-deep .cs-col {
    padding: 0 !important;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .box-outer {
    padding: 10px;
  }
  .cs-field {
    padding: 0 20px;
  }
  ::ng-deep .cs-col {
    padding: 10px !important;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .about-form-wrapper {
    margin-left: 10px;
    margin-right: 10px;
  }
  .box {
    padding: 40px;
  }
  .cs-field {
    padding: 0 20px;
  }
  ::ng-deep .cs-col {
    padding: 10px !important;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .about-form-wrapper {
    margin-left: 10px;
    margin-right: 10px;
  }
  .box {
    padding: 40px;
  }
  .cs-field {
    padding: 0 20px;
  }
  ::ng-deep .cs-col {
    padding: 20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/common/about/about.component.scss"],"names":[],"mappings":"AACE;EACE,0BAAA;AAAJ;AAGE;EACE,uBAAA;EACA,gCAAA;AADJ;;AAKA;EACE,WAAA;AAFF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;AAAF;AACE;EACE,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AACJ;;AAEA;EACE,UAAA;EACA,cAAA;AACF;;AACA;EACE,WAAA;EACA,YAAA;AAEF;;AAAA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;AAGF;;AADA;EACE,mBAAA;EACA,cAAA;EACA,YAAA;AAIF;;AAFA;EACE,kDAAA;EACA,kCAAA;EACA,4BAAA;EACA,sBAAA;AAKF;;AAHA;EACE,2CAAA;EACA,WAAA;AAMF;;AAJA;EACE;IACE,mCAAA;IACA,2BAAA;IACA,0CAAA;EAOF;EALA;IACE,aAAA;EAOF;AACF;AAGA,iDAAA;AACA;EACE;IACE,UAAA;EADF;EAGA;IACE,eAAA;EADF;EAIE;IACE,qBAAA;EAFJ;AACF;AAMA,oEAAA;AACA;EACE;IACE,UAAA;EAJF;EAMA;IACE,eAAA;EAJF;EAOE;IACE,qBAAA;EALJ;AACF;AASA,qDAAA;AACA;EACE;IACE,aAAA;EAPF;EASA;IACE,eAAA;EAPF;EAUE;IACE,wBAAA;EARJ;AACF;AAYA,mDAAA;AACA;EACE;IACE,iBAAA;IACA,kBAAA;EAVF;EAYA;IACE,aAAA;EAVF;EAYA;IACE,eAAA;EAVF;EAaE;IACE,wBAAA;EAXJ;AACF;AAeA,oEAAA;AACA;EACE;IACE,iBAAA;IACA,kBAAA;EAbF;EAeA;IACE,aAAA;EAbF;EAeA;IACE,eAAA;EAbF;EAgBE;IACE,wBAAA;EAdJ;AACF","sourcesContent":["::ng-deep {\n  .cs-p {\n    font-size: 2rem !important;\n  }\n\n  .about-form-wrapper {\n    border: none !important;\n    border-radius: 1.5rem !important;\n  }\n}\n\np-accordion, app-ready-for-solar {\n  width: 100%;\n}\n.cs-field {\n  display: flex;\n  margin-bottom: 1rem;\n}\n.cs-number {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  border: 5px solid var(--secondary);\n  font-size: 32px;\n  display: flex;\n  justify-content: center;\n  line-height: 50px;\n  p {\n    color: var(--secondary);\n    line-height: normal;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n.about-form-wrapper {\n  padding: 0;\n  overflow: auto;\n}\n.max-content {\n  width: 100%;\n  height: 100%;\n}\n.box-outer {\n  display: table;\n  overflow: hidden;\n  padding: 20px;\n  z-index: 1;\n}\n.box-inner {\n  display: table-cell;\n  overflow: auto;\n  filter: none;\n}\n.bg-image {\n  background-image: url('../../../assets/images/rooftop-solar-suburb.jpeg');\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.modal-2 {\n  background-color: rgba(255, 255, 255, 0.95);\n  color: #000;\n}\n@supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {\n  .modal-2 {\n    -webkit-backdrop-filter: blur(15px);\n    backdrop-filter: blur(15px);\n    background-color: rgba(255, 255, 255, 0.4);\n  }\n  .warning {\n    display: none;\n  }\n}\n\n\n\n\n\n\n\n\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 600px) {\n  .box-outer {\n    padding: 0;\n  }\n  .cs-field {\n    padding: 0 10px;\n  }\n  ::ng-deep {\n    .cs-col {\n      padding: 0 !important;\n    }\n  }\n}\n\n/* Small devices (portrait tablets and large phones, 600px and up) */\n@media only screen and (min-width: 600px) {\n  .box-outer {\n    padding: 0;\n  }\n  .cs-field {\n    padding: 0 10px;\n  }\n  ::ng-deep {\n    .cs-col {\n      padding: 0 !important;\n    }\n  }\n}\n\n/* Medium devices (landscape tablets, 768px and up) */\n@media only screen and (min-width: 768px) {\n  .box-outer {\n    padding: 10px;\n  }\n  .cs-field {\n    padding: 0 20px;\n  }\n  ::ng-deep {\n    .cs-col {\n      padding: 10px !important;\n    }\n  }\n}\n\n/* Large devices (laptops/desktops, 992px and up) */\n@media only screen and (min-width: 992px) {\n  .about-form-wrapper {\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n  .box {\n    padding: 40px;\n  }\n  .cs-field {\n    padding: 0 20px;\n  }\n  ::ng-deep {\n    .cs-col {\n      padding: 10px !important;\n    }\n  }\n}\n\n/* Extra large devices (large laptops and desktops, 1200px and up) */\n@media only screen and (min-width: 1200px) {\n  .about-form-wrapper {\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n  .box {\n    padding: 40px;\n  }\n  .cs-field {\n    padding: 0 20px;\n  }\n  ::ng-deep {\n    .cs-col {\n      padding: 20px !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
